var productJsonElement = document.querySelector('[data-product-json]');
var productData = JSON.parse(productJsonElement.innerHTML);
var titleColours = JSON.parse(document.querySelector('[data-title-colours-json]').innerHTML);
var guaranteedColours = JSON.parse(document.querySelector('[data-guaranteed-colours-json]').innerHTML);
var flavourColours = JSON.parse(document.querySelector('[data-flavour-colours-json]').innerHTML);
var priceColours = JSON.parse(document.querySelector('[data-price-colours-json]').innerHTML);
var valueColours = JSON.parse(document.querySelector('[data-value-colours-json]').innerHTML);
var oneTimeColours = JSON.parse(document.querySelector('[data-one-time-colours-json]').innerHTML);
var subscribeColours = JSON.parse(document.querySelector('[data-subscribe-colours-json]').innerHTML);
var headerActiveColours = JSON.parse(document.querySelector('[data-header-active-colours-json]').innerHTML);
var subscriptionDescriptionColours = JSON.parse(document.querySelector('[data-subscription-description-colours-json]').innerHTML);

var productTitleElement = document.querySelector('.product-meta__title');
var productDescriptionElement = document.querySelector('.product-meta__description');
var guaranteedTextElement = document.querySelector('.product-meta__guaranteed-text');
var guaranteedIconElement = document.querySelector('.product-meta__guaranteed-icon');
var flavourValueElement = document.querySelector('.product-form__option-value');
var flavourTitleElement = document.querySelector('.product-form__option-name');
var priceElement = document.querySelector('.product-form__price');
var caseElement = document.querySelector('.product-form__case');
var oneTimeElement = document.querySelector('.stay-selling-plan-group-header[data-one-time]');
var subscribeElement = document.querySelector('.stay-selling-plan-group-header[data-subscribe]');
var subscriptionDescriptionElement = document.querySelector('[data-subscription-description]');
var advantagesElement = document.querySelector('.smarttr__advantages');

function updateVariantId() {
	var variantSelect = document.querySelector('[name="id"]');
	var selectedVariantId = variantSelect.value;

	var titleColor = titleColours[selectedVariantId];
	var guaranteedColor = guaranteedColours[selectedVariantId];
	var flavourColor = flavourColours[selectedVariantId];
	var priceColor = priceColours[selectedVariantId];
	var valueColor = valueColours[selectedVariantId];
	var oneTimeColor = oneTimeColours[selectedVariantId];
	var subscribeColor = subscribeColours[selectedVariantId];
	var subscriptionDescriptionColor = subscriptionDescriptionColours[selectedVariantId];
	var headerActiveColor = headerActiveColours[selectedVariantId];

	productTitleElement.style.color = titleColor;
	productDescriptionElement.style.color = titleColor;
	guaranteedTextElement && (guaranteedTextElement.style.color = guaranteedColor);
	guaranteedIconElement && (guaranteedIconElement.style.stroke = guaranteedColor);
	flavourValueElement.style.color = flavourColor;
	flavourTitleElement.style.color = flavourColor;
	flavourValueElement.style.opacity = '0.7';
	priceElement.style.color = priceColor;
	caseElement.style.color = valueColor;
	if (oneTimeElement) oneTimeElement.style.color = oneTimeColor;
	if (subscribeElement) subscribeElement.style.color = subscribeColor;
	if (subscriptionDescriptionElement) subscriptionDescriptionElement.style.color = subscriptionDescriptionColor;
	if (advantagesElement) advantagesElement.style.color = subscriptionDescriptionColor;

	document.documentElement.style.setProperty('--one-time-color', oneTimeColor);
	document.documentElement.style.setProperty('--subscribe-color', subscribeColor);
	document.documentElement.style.setProperty('--subscription-description-color', subscriptionDescriptionColor);
	document.documentElement.style.setProperty('--header-active-color', headerActiveColor);
	document.documentElement.style.setProperty('--title-color', titleColor);
}

function updateReviewColor() {
	var yotpoBottomlineLink = document.querySelector('.yotpo-bottomline a');

	if (yotpoBottomlineLink) {
		console.log('Yotpo Bottomline Link:', yotpoBottomlineLink);
	var variantSelect = document.querySelector('[name="id"]');
	var selectedVariantId = variantSelect.value;
	var titleColor = titleColours[selectedVariantId];
	var style = document.createElement('style');
	style.innerHTML = `
					.product__container .yotpo a {
							color: ${titleColor} !important;
					}
			`;
	document.head.appendChild(style);
	}
}

document.addEventListener('DOMContentLoaded', function () {
	var variantSelect = document.querySelector('[name="id"]');
	variantSelect.addEventListener('change', updateVariantId);

	var optionRadios = document.querySelectorAll('.product-form__option-radio');
	optionRadios.forEach(function (radio) {
		radio.addEventListener('change', function () {
			var variantId = this.getAttribute('data-variant-id');
			var selectedFlavor = this.value;
			var selectedVariant = productData.variants.find(variant => variant.options.includes(selectedFlavor));
			var subscriptionBlock = document.querySelector('[data-stay-selling-plan-group-id][data-current-variant]')

			if (subscriptionBlock) {
              subscriptionBlock.setAttribute('data-current-variant', variantId);
			}

			if (selectedVariant) {
				variantSelect.value = selectedVariant.id;
				updateVariantId();
				updateReviewColor();
			}
		});
	});

	updateVariantId();
	updateReviewColor();
});

window.onload = function () {
	updateReviewColor();
}

